import { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'

interface CopyableTextProps {
  text: string
  className?: string
  iconSize?: string
  toastMessage?: string
}

export function CopyableText({
  text,
  className,
  iconSize = 'size-3',
  toastMessage = 'Copied to clipboard',
}: CopyableTextProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
    navigator.clipboard.writeText(text)
    setCopied(true)
    toast.success(toastMessage)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <span className={cn('inline-flex items-center gap-1 group/copy', className)}>
      <span className="truncate">{text}</span>
      <button
        type="button"
        onClick={handleCopy}
        className="shrink-0 p-0.5 rounded hover:bg-muted transition-colors cursor-pointer opacity-0 group-hover/copy:opacity-100"
        title="Copy"
      >
        {copied ? (
          <Check className={cn(iconSize, 'text-primary')} />
        ) : (
          <Copy className={cn(iconSize, 'text-muted-foreground')} />
        )}
      </button>
    </span>
  )
}
